import {
  // setUser,
  // setInvitationUser,
  addInvitationUser,
  removeUser,
  removeInvitation,
  updateUser,
  updateInvitation
} from "stores/slice/bogus/userManagement/msp/const";

const mspUserManagementConfig = {
  // List Enterprise Users
  "/ents/:entId/users.read": {
    protocol: "ws",
    resource: "/ents/:entId/users",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "mspUserManagement.users",
  },
  // List Pending Enterprise Invitations
  "/ents/:entId/invitations.read": {
    protocol: "ws",
    resource: "/ents/:entId/invitations",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "mspUserManagement.invitations",
  },
  // Remove an Enterprise User
  "/ents/:entId/users/:userId.delete": {
    protocol: "ws",
    resource: "/ents/:entId/users/:userId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ entId: params.entId, userId: params.userId }),
    action: removeUser,
    mockSelector: "mspUserManagement.users",
  },
  // Cancel an Enterprise Invitation
  "/ents/:entId/invitations/:invitationId.delete": {
    protocol: "ws",
    resource: "/ents/:entId/invitations/:invitationId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({
      entId: params.entId,
      invitationId: params.invitationId,
    }),

    action: removeInvitation,
    mockSelector: "mspUserManagement.invitations",
  },
  // Create an Enterprise Invitation
  "/ents/:entId/invitations.create": {
    protocol: "ws",
    resource: "/ents/:entId/invitations",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: addInvitationUser,
    mockSelector: "mspUserManagement.invitations",
  },
  // Update an Enterprise Invitation
  "ents/:entId/invitations/:invitationId.update": {
    protocol: "ws",
    resource: "/ents/:entId/invitations/:invitationId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: updateInvitation,
    mockSelector: "mspUserManagement.invitations",
  },
  // Update an Enterprise User
  "ents/:entId/users/:userId.update": {
    protocol: "ws",
    resource: "/ents/:entId/users/:userId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates  }),
    action: updateUser,
    mockSelector: "mspUserManagement.users",
  },
  // Resend an Enterprise Invitation
  "ents/:entId/invitations/:invitationId.resend": {
    protocol: "ws",
    resource: "/ents/:entId/invitations/:invitationId/resend",
    restful: true,
    method: "update",
    buildParams: null,
    action: null,
    mockSelector: "mspUserManagement.invitations",
  },
};

export default mspUserManagementConfig;
